import { render, staticRenderFns } from "./EsportMatchCard.vue?vue&type=template&id=9ec34d58&scoped=true"
import script from "./EsportMatchCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EsportMatchCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EsportMatchCard.vue?vue&type=style&index=0&id=9ec34d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec34d58",
  null
  
)

export default component.exports